import { Component, OnInit } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { ActivatedRoute } from '@angular/router';
import { JoiApp, JoiAppData, JoiAppInfo } from 'globals/store/app.data';
import { mobileAppSubpageReselector } from '../mobile-store/mobile.app.routing.reselector';
import { MobileAppSubpage } from '../mobile-store/mobile.data';
import { loadProgramTexts } from 'globals/store/programs.data';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { Subject } from 'rxjs';
import { LabelSelectorDialog } from '../../publish-timeline/label-selector.dialog';
import { getSelectableLabelGroups } from 'globals/store/publish.data';
import { PublicTimelineItem } from 'globals/store/public.model';
import { openDialogGetResult } from '../../../helpers/angular-helpers';
import { PublishTimelineViewComponent } from '../../publish-timeline/publish-timeline-view.component';
import { IconTextComponent } from '../../buttons/icon-text.component';
import { IconComponent } from '../../icon/icon.component';
import { CommonModule } from '@angular/common';
import { SmallButtonComponent } from '../../buttons/small-button.component';
import { LabelSelectorData, SelectableLabelGroup } from 'globals/store/dialog.selector.data';
import { mobileAppFeature } from '../mobile-store/mobile.app.era';

@Component({
    selector: 'mobile-app-program',
    template: `
<div id="filterIcon" class="extra-filters">
  <small-button *ngIf="subPage === 'agenda'" (click)="editingAgenda ? saveAgenda() : editAgenda()">
    {{ editingAgenda ? 'SAVE' : 'UPDATE AGENDA' }}
  </small-button>
  <!--<small-button *ngIf="subPage === 'agenda' && editingAgenda" class="reset" (click)="resetAgenda()">
    RESET
  </small-button>-->
  <div style="flex: 1"></div>
  <icon [icon]="'grow'" (click)="expandAll()"></icon>
  <icon [icon]="'shrink'" (click)="collapseAll()"></icon>
  <icon-text *ngIf="subPage !== 'agenda' && !!labelGroups?.length"
    [active]="!!extraFiltersIds.size" 
    [text]="'Filter'" 
    (click)="openExtraFilters()"
  ></icon-text>
</div>
<publish-timeline-view *ngIf="!!timeline"
  [timeline]="timeline"
  [breakDays]="app?.eventData?.excludedFieldIds?.includes('breakDays')"
  [checkedSessionIds]="editingAgenda ? appData?.selectedSessionIds : null"
  [programTexts]="programTexts"
  [excludedFieldIds]="app?.eventData?.excludedFieldIds"
  [joiEvent]="app?.eventData?.eventInfo"
  [$toggleAll]="$toggleAll"
></publish-timeline-view>
`,
    styleUrls: ['./mobile-app-program.scss'],
    standalone: true,
    imports: [PublishTimelineViewComponent, IconTextComponent, IconComponent, CommonModule, SmallButtonComponent]
})
export class MobileAppProgramComponent extends MobileAppWrapper<MobileAppProgramComponent> {
  subPages: MobileAppSubpage[] = ['program', 'agenda']  
  subPage: MobileAppSubpage
  appInfo: JoiAppInfo
  appData: JoiAppData
  appId: string
  app: JoiApp
  programTexts = {}
  $toggleAll: Subject<boolean> = new Subject()

  
  tabNames:{ [tId: string]: string } = getDefaultProgramTabNames() 
  labelGroups: SelectableLabelGroup[]
  extraFiltersIds: Set<string> = new Set()
  timeline: PublicTimelineItem[][]
  editingAgenda = false

  constructor() {
    super()
    console.log("In mobile app program constructor")
    this.selectCallback(mobileAppSubpageReselector, null, subPage => {
      this.subPage = subPage
      this.loadTimeline() // needs this order
      this.loadFilters() // needs this order
    })
    this.subProp(this.store.select(mobileAppFeature.selectId), 'appId')
    this.subCallback(this.store.select(mobileAppFeature.selectAppData), appData => {
      this.appData = appData
      this.loadTimeline() // needs this order
      this.loadFilters() // needs this order
    })

    this.subCallback(this.store.select(mobileAppFeature.selectApp), app => {
      this.app = app
      this.loadTimeline() // needs this order
      this.loadFilters() // needs this order
      if (!app) return
      const { tabNames, timeline, excludedFieldIds, eventInfo } = app.eventData
      if (tabNames) this.tabNames = tabNames
      this.programTexts = loadProgramTexts(timeline, excludedFieldIds, eventInfo.venues)
    })
  }

  editAgenda() {
    this.timeline = this.app.eventData.timeline // need to show everything
    this.editingAgenda = true
  }

  saveAgenda() {
    this.editingAgenda = false
    this.mobileAppService.saveAppData(this.appData) // save selections
    this.loadTimeline() // needs this order
    this.loadFilters() // needs this order
  }

  resetAgenda() {
    this.editingAgenda = false
    this.appData.selectedSessionIds = []
    this.mobileAppService.saveAppData(this.appData) // save selections
    this.loadTimeline() // needs this order
    this.loadFilters() // needs this order
  }

  expandAll() {
    this.$toggleAll.next(true)
  }

  collapseAll() {
    this.$toggleAll.next(false)
  }

  changeSubpage(subPage: MobileAppSubpage) {
    this.mobileAppService.changeSubpage(subPage)
  }

  loadFilters() {
    if (!this.app?.eventData) return 
    const { eventInfo } = this.app.eventData
    const { session_labels } = eventInfo
    if (session_labels) {
      const sessionLabelIds: Set<string> =  new Set((this.timeline as any).flat().map(s => s.labels).filter(l => l).flat())
      this.labelGroups = getSelectableLabelGroups(sessionLabelIds, session_labels)
    }
  }

  
  async openExtraFilters() {
    const el: HTMLElement = document.getElementById('filterIcon')
    const rect = el.getBoundingClientRect()
    const { bottom, right, x } = rect
    const data: LabelSelectorData = {
      instructions: null,
      position: { left: right - 290, top: bottom + 4 },
      labelGroups: this.labelGroups,
      template: this.app.brandingData.template
    }
    const labels: SelectableLabelGroup[] = await openDialogGetResult<SelectableLabelGroup[]>(this.dialog, LabelSelectorDialog, { width: '290px', disableClose: false, autoFocus: false, data, backdropClass: 'clear' })
    const newIds = new Set<string>(labels[0].labels.filter(l => l.selected).map(l => l.id))
    this.extraFiltersIds = newIds
    this.loadTimeline()
  }

  loadTimeline() {
    const timeline = this.app?.eventData?.timeline
    if (!timeline || !this.subPage) return
    this.timeline = []
    const sessionIds = this.appData?.selectedSessionIds || []
    for (let i = 0; i < timeline.length; i++) {
      const day = timeline[i].filter(session => [
        this.subPage === 'agenda' || !this.extraFiltersIds.size || (session.labels && session.labels.some(l => this.extraFiltersIds.has(l))),
        this.subPage !== 'agenda' || !sessionIds.length || sessionIds.includes(session.id)
      ].every(passes => passes))
      if (day.length) this.timeline.push(day)
    }
  }
  

}

